import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import GlobalErrorFallback from './GlobalErrorFallback';

const GlobalErrorBoundary = ({ children }) => (
  <ErrorBoundary FallbackComponent={GlobalErrorFallback}>
    {children}
  </ErrorBoundary>
);

export default GlobalErrorBoundary;